/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrigineRicarica } from './origine-ricarica';
import { ServizioMensaRicaricaStato } from './servizio-mensa-ricarica-stato';


export interface ServizioMensaRicaricaDTO { 
    id?: string;
    data?: string;
    data_pagamento?: string;
    numero_bollettino?: string;
    valore?: number;
    operatore?: string;
    note?: string;
    metodo_pagamento?: string;
    identificativo_univoco_versamento?: string;
    identificativo_univoco_dovuto?: string;
    numero_avviso?: string;
    id_flusso?: string;
    qr_code?: string;
    stato?: string;
    stato_interno?: ServizioMensaRicaricaStato;
    pagamento_da_verificare?: boolean;
    verifica_in_ritardo?: boolean;
    origine?: OrigineRicarica;
}



